import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

let swiper;

const breakpoint = window.matchMedia('(min-width:1024px)');

const breakpointChecker = function () {
  if (breakpoint.matches) {
    return enableThumbnailSwiper();
  } else {
    return enableMobileGallerySwiper();
  }
};

const enableMobileGallerySwiper = function () {
  swiper = new Swiper('#main-product .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
  });
};

const enableThumbnailSwiper = function () {
  swiper = new Swiper('#main-product .thumbnail-slider .swiper', {
    modules: [Navigation, Pagination],
    direction: 'vertical',
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      nextEl: '.slider-button--next',
      prevEl: '.slider-button--prev',
    },
  });
};

breakpoint.addEventListener('change', breakpointChecker);
breakpointChecker();
